'use strict';

import 'lib/jquery.hoverdir';

// hover functionality
if (window.innerWidth > 775) {
  $('.js-fancy-overlay').hoverdir({
    hoverElem: '.hoverelem',
    speed: 100
  });
}

const sectionShavee = $('#head-shaving')[0].offsetTop;
const navHeight = $('#navigation').height() - 2;

function animateButton () {
  const windowPosition = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

  if (windowPosition > sectionShavee - navHeight) {
    $('#js-animated-buttons').addClass('animate-buttons');
    $('#navigation').removeClass('animate-nav');
  } else {
    $('#js-animated-buttons').removeClass('animate-buttons');
    $('#navigation').addClass('animate-nav');
  }
  window.requestAnimationFrame(animateButton);
}
window.requestAnimationFrame(animateButton);

// Fancy Nav Scroll with Section
const aChildren = $('#special-navigation li').children();
const aArray = [];
for (let i = 0; i < aChildren.length; i++) {
  const aChild = aChildren[i];
  const ahref = $(aChild).attr('href');
  aArray.push(ahref);
}

const sectionValues = [];
let revealedByScroll = false;
let oldWindowPos = 0;

$('#navigation, #top-nav').find('a').on('click', function (e) {
  e.preventDefault();
  const navDisabled = $(this).parent().hasClass('disable-nav');
  if (!navDisabled) {
    const id = $(this).attr('href');
    const navHeight = $('#navigation').height() - 2;
    $('html, body').animate({
      scrollTop: $(id).offset().top - navHeight
    }, 500);
  }
});

for (let i = 0; i < aArray.length; i++) {
  const theHref = aArray[i];
  const divPos = $(theHref).offset().top;
  const divHeight = $(theHref).outerHeight();
  const $parent = $(`[href="${theHref}"].special-nav-item`).parent();

  sectionValues.push({
    pos: divPos,
    height: divHeight,
    $parent
  });
}

let currentSection = 0;
let isScrollingUp = false;

function handleScrollingNavigation () {
  const windowPos = $(window).scrollTop();
  const modifiedPos = windowPos + 60;
  if (windowPos !== oldWindowPos) {
    isScrollingUp = windowPos > oldWindowPos;
  }

  for (let i = sectionValues.length - 1; i >= 0; i--) {
    const { $parent } = sectionValues[i];
    const divPos = sectionValues[i].pos - navHeight;
    const divHeight = sectionValues[i].height;

    if (modifiedPos >= divPos && modifiedPos < (divPos + divHeight)) {
      currentSection = i;

      if (isScrollingUp) {
        $parent.removeClass('nav-go-right');
      } else {
        $parent.addClass('nav-go-right');
      }

      if (!$parent.hasClass('active')) {
        $parent.addClass('active');
        revealedByScroll = true;
      }
    } else {
      if (revealedByScroll) {
        $parent.removeClass('active');
      }

      if (i > currentSection) {
        $parent.removeClass('nav-go-right');
      } else {
        $parent.addClass('nav-go-right');
      }
    }
  }
  oldWindowPos = windowPos;
  window.requestAnimationFrame(handleScrollingNavigation);
}
window.requestAnimationFrame(handleScrollingNavigation);
